import { STATE } from "@core/state";
import { on } from "@utils/listener";

class SiteBackdrop {
  constructor(el, emitter) {
    this.el = el;
    this.emitter = emitter;

    this._initialized = false;

    this._onClick = this._onClick.bind(this);
    this._onShow = this._onShow.bind(this);
    this._onHide = this._onHide.bind(this);
  }

  init() {
    if( this._initialized ) return;
    this._initialized = true;

    this._bindEvents();
  }

  _bindEvents() {
    on(this.el, 'click', this._onClick);

    this.emitter.on('FavoriteRestaurant.open', this._onShow);
    this.emitter.on('FavoriteRestaurant.close', this._onHide);
    this.emitter.on('SiteNav.open', this._onShow);
    this.emitter.on('SiteNav.close', this._onHide);
  }

  _onClick(event) {
    if( event ) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }

    this.emitter.emit('SiteBackdrop.click');
  }
  _onShow() { this.el.setAttribute('aria-hidden', false); }
  _onHide() {
    if( STATE.siteNavOpen || STATE.favoriteRestaurantNav ) return;

    this.el.setAttribute('aria-hidden', true);
  }
}

export default SiteBackdrop;
